import { MaybeRef, Ref, type UnwrapRef } from "vue";
import axios from "@/main";
import { debounce, DebouncedFunc } from "lodash-es";
import { emitter, MittType } from "@/plugins/event-bus";
import { FormItemRule } from "element-plus/es/components/form/src/types";

export interface RuleMixins {
  emailRule: any;
  phoneNumberRule: any;
  phoneRusNumberRule: any;
  phoneNumberRuleWoPrefix: any;
  storeNumberRule: any;
  clientNumberRule: any;
  cardNumberRule: any;
  requiredRule: any;
  emailsRule: any;
  uniqueRule: any;
}
interface loadingModel {
  loading?: boolean;
}

const debouncedCheckIfUnique = debounce(
  (rule: any, value: any, callback: any, url: string, id: Ref<string>, model?: loadingModel) => {
    if (value) {
      // model && (model.loading = true);  // TODO реализовать loading анимацию?
      axios
        .get(
          `${url}?${new URLSearchParams({
            id: id.value || "",
            value: value.trim(),
            fieldName: rule.field,
          }).toString()}`
        )
        .then((res: any) => {
          if (res.data) {
            callback();
          } else {
            callback(new Error("Поле должно быть уникальным"));
          }
          emitter.emit(MittType.asyncValidationEnds);
        });
      //.finally(() => model && (model.loading = false)); // TODO реализовать loading анимацию?
    } else {
      callback();
      emitter.emit(MittType.asyncValidationEnds);
    }
  },
  300
);

export const ruleMixins: RuleMixins = {
  emailRule: {
    type: "email",
    message: "Необходимо ввести корректный email",
    trigger: "change",
  },
  phoneNumberRule: {
    pattern: /^(|\+|(\+[0-9]{11}))$/,
    message: "Номер телефона указан в неправильном формате",
    trigger: "change",
  },
  phoneRusNumberRule: {
    pattern: /^\+79[0-9]{9}$/,
    message: "Номер телефона указан в неправильном формате",
    trigger: "change",
  },
  phoneNumberRuleWoPrefix: {
    pattern: /^[0-9]{10}$/,
    message: "Номер телефона указан в неправильном формате",
    trigger: "change",
  },
  storeNumberRule: { min: 2, max: 3, message: "Поле должно содержать 2-3 символа", trigger: "change" },
  clientNumberRule: { min: 12, max: 13, message: "Поле должно содержать 12 или 13 цифр", trigger: "change" },
  cardNumberRule: {
    pattern: /^\d{22}$/,
    message: "Номер карты должен состоять из 22 цифр",
    trigger: "change",
  },
  requiredRule: {
    required: true,
    message: `Поле не может быть пустым`,
    trigger: "change",
  },
  emailsRule: {
    pattern: /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,10})(, ?[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,10})*$/,
    message: "Необходимо ввести корректную почту, разделенную запятыми",
    trigger: ["blur"],
  },
  uniqueRule: (url: string, id: Ref<string>, model?: loadingModel) => ({
    validator: (rule: any, value: any, callback: any) =>
      debouncedCheckIfUnique(rule, value, callback, url, id, model),
    trigger: ["blur", "change"],
    debounceFunction: debouncedCheckIfUnique,
  }),
};

export default {
  methods: ruleMixins,
};

export interface FormItemDebounceRule extends FormItemRule {
  debounceFunction?: DebouncedFunc<any>;
}
